import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers/rootReducer';

let middlewares = [thunk];

if (!import.meta.env.VITE_MODE || import.meta.env.VITE_MODE === 'development') {
  const logger = createLogger({
    collapsed: true,
    diff: true,
  });

  middlewares = [...middlewares, logger];
}

const store = createStore(rootReducer, applyMiddleware(...middlewares));
export default store;
